"use strict";

exports.__esModule = true;
exports.ReportsManager = exports.ReportingParams = void 0;
var _ConversionUtils = require("../Utils/ConversionUtils");
var _TrackingReport = require("./TrackingReport");
var _YoLog = require("../Utils/YoLog");
var _HttpUtils = require("../Utils/HttpUtils");
var _StringUtils = require("../Utils/StringUtils");
var _HttpConnection = require("../Utils/HttpConnection");
var _CallbackHelper = require("../Utils/CallbackHelper");
var _TrackingError = require("../Public/TrackingError");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
var ReportsManager = exports.ReportsManager = /*#__PURE__*/function () {
  function ReportsManager(properties, addTrackingError) {
    /** @private */
    this.properties = properties;
    /** @private */
    this.suppress = false;
    /** @private */
    this.observers = [];
    /** @private */
    this.addTrackingError = addTrackingError;
  }
  var _proto = ReportsManager.prototype;
  _proto.addAnalyticObserver = function addAnalyticObserver(listener) {
    if (!listener) {
      _YoLog.YoLog.e("addAnalyticObserver: listener was null");
    } else {
      this.observers.push(listener);
    }
  };
  _proto.applyEncryptedTracking = function applyEncryptedTracking(url) {
    if (this.properties.getApplyEncryptedTracking()) {
      url = url.replace("http:", "https:");
    }
    return url;
  };
  _proto.fire = function fire(report, params) {
    var _this = this;
    var opts = {
      method: "GET"
    };
    if (!this.properties.getAllowCorsForAnalytics()) {
      opts.mode = "no-cors";
    } else if (!(0, _StringUtils.isNullOrEmpty)(this.properties.getUserAgent())) {
      opts.headers = (0, _HttpUtils.createHeaders)(this.properties.getUserAgent());
    }
    var _loop = function _loop() {
      var url = _step.value;
      _this.performMacroSubstitutionForUrl(url, params);
      _this.applyEncryptedTracking(url);
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_REPORTS, "Firing report url: " + url);
      _HttpConnection.HttpConnection.get(url, opts, _this.properties.getResourceTimeout()).then(function (response) {
        if (!response.ok && response.status !== 0) {
          var trackingError = new _TrackingError.TrackingError(url, response.status, report.trackingEvent, report.getAdBreakIdentifier(), report.getMediaIdentifier());
          _this.addTrackingError(trackingError);
        }
      });
    };
    for (var _iterator = _createForOfIteratorHelperLoose(report.getTrackingUrls()), _step; !(_step = _iterator()).done;) {
      _loop();
    }
  };
  _proto.fireBeacon = function fireBeacon(report, params) {
    if (report && report.getTrackingUrls().length > 0 && !this.shouldSuppress(report.event)) {
      try {
        this.fire(report, params);
      } catch (e) {
        _YoLog.YoLog.e("Unable to fire tracking URLs for report: " + e);
        throw e;
      }
    }
  };
  _proto.fireBeacons = function fireBeacons(reports, params) {
    var trackingUrls = [];
    for (var _iterator2 = _createForOfIteratorHelperLoose(reports), _step2; !(_step2 = _iterator2()).done;) {
      var report = _step2.value;
      for (var _iterator3 = _createForOfIteratorHelperLoose(report.getTrackingUrls()), _step3; !(_step3 = _iterator3()).done;) {
        var trackingUrl = _step3.value;
        trackingUrls.push(trackingUrl);
      }
    }
    this.fireBeacon(new _TrackingReport.TrackingReport("", trackingUrls), params);
  };
  _proto.performMacroSubstitutionForUrl = function performMacroSubstitutionForUrl(url, params) {
    var assetUri = "";
    var timeStamp = (0, _ConversionUtils.millisToTimestamp)(Date.now());
    var timeStr = (0, _ConversionUtils.millisToTimeString)(params.getPlayhead());
    var advertTimeStr = params.getAdvertStart() === -1 ? "-1" : (0, _ConversionUtils.millisToTimeString)(params.getAdvertStart());
    assetUri = encodeURIComponent(params.getAssetUri());
    timeStamp = encodeURIComponent(timeStamp);
    timeStr = encodeURIComponent(timeStr);
    advertTimeStr = encodeURIComponent(advertTimeStr);
    var rnd = 10000000 + Math.round(Math.random() * 100000000);
    url = url.replace("[ASSETURI]", assetUri).replace("%5BASSETURI%5D", assetUri).replace("[CACHEBUSTING]", rnd).replace("%5BCACHEBUSTING%5D", rnd).replace("[TIMESTAMP]", timeStamp).replace("%5BTIMESTAMP%5D", timeStamp).replace("[CONTENTPLAYHEAD]", timeStr).replace("%5BCONTENTPLAYHEAD%5D", timeStr).replace("[MEDIAPLAYHEAD]", timeStr).replace("%5BMEDIAPLAYHEAD%5D", timeStr).replace("[ADPLAYHEAD]", advertTimeStr).replace("%5BADPLAYHEAD%5D", advertTimeStr);

    // Replace any client-specified macros
    for (var _iterator4 = _createForOfIteratorHelperLoose(params.getMacroSubstitutions()), _step4; !(_step4 = _iterator4()).done;) {
      var _step4$value = _step4.value,
        key = _step4$value[0],
        value = _step4$value[1];
      url = url.replace("[" + key + "]", value).replace("%5B" + key + "%5D", value);
    }

    // Replace any unknown macros
    url = url.replace(/\[(.*?)]/g, "-1");
    url = url.replace(/%5B(.*)%5D/g, "-1");
    return url;
  };
  _proto.raiseAdBreakEarlyReturn = function raiseAdBreakEarlyReturn(adBreak, session) {
    _YoLog.YoLog.trace("earlyreturn");
    for (var _iterator5 = _createForOfIteratorHelperLoose(this.observers), _step5; !(_step5 = _iterator5()).done;) {
      var observer = _step5.value;
      (0, _CallbackHelper.raiseCallback)(observer, observer.onAdvertBreakEarlyReturn, adBreak, session);
    }
  };
  _proto.raiseAdBreakCallback = function raiseAdBreakCallback(event, adbreak, session) {
    if (event === "start") {
      for (var _iterator6 = _createForOfIteratorHelperLoose(this.observers), _step6; !(_step6 = _iterator6()).done;) {
        var observer = _step6.value;
        (0, _CallbackHelper.raiseCallback)(observer, observer.onAdvertBreakStart, adbreak, session);
      }
    } else if (event === "end") {
      for (var _iterator7 = _createForOfIteratorHelperLoose(this.observers), _step7; !(_step7 = _iterator7()).done;) {
        var _observer = _step7.value;
        (0, _CallbackHelper.raiseCallback)(_observer, _observer.onAdvertBreakEnd, session);
      }
    }
  };
  _proto.raiseAdvertCallback = function raiseAdvertCallback(event, advert, session) {
    if (event === "start") {
      for (var _iterator8 = _createForOfIteratorHelperLoose(this.observers), _step8; !(_step8 = _iterator8()).done;) {
        var observer = _step8.value;
        (0, _CallbackHelper.raiseCallback)(observer, observer.onAdvertStart, advert, session);
      }
    } else if (event === "end") {
      for (var _iterator9 = _createForOfIteratorHelperLoose(this.observers), _step9; !(_step9 = _iterator9()).done;) {
        var _observer2 = _step9.value;
        (0, _CallbackHelper.raiseCallback)(_observer2, _observer2.onAdvertEnd, session);
      }
    }
  };
  _proto.raiseAnalyticUpdateCallback = function raiseAnalyticUpdateCallback(session) {
    if (!this.suppress) {
      for (var _iterator10 = _createForOfIteratorHelperLoose(this.observers), _step10; !(_step10 = _iterator10()).done;) {
        var observer = _step10.value;
        (0, _CallbackHelper.raiseCallback)(observer, observer.onAnalyticUpdate, session);
      }
    }
  };
  _proto.raiseSessionErrorCallback = function raiseSessionErrorCallback(errorCode, session) {
    for (var _iterator11 = _createForOfIteratorHelperLoose(this.observers), _step11; !(_step11 = _iterator11()).done;) {
      var observer = _step11.value;
      (0, _CallbackHelper.raiseCallback)(observer, observer.onSessionError, errorCode, session);
    }
  };
  _proto.raiseTrackingCallback = function raiseTrackingCallback(event, session) {
    if (!this.shouldSuppress(event)) {
      for (var _iterator12 = _createForOfIteratorHelperLoose(this.observers), _step12; !(_step12 = _iterator12()).done;) {
        var observer = _step12.value;
        (0, _CallbackHelper.raiseCallback)(observer, observer.onTrackingEvent, event, session);
      }
    }
  };
  _proto.raiseTrackingErrorCallback = function raiseTrackingErrorCallback(trackingError, session) {
    for (var _iterator13 = _createForOfIteratorHelperLoose(this.observers), _step13; !(_step13 = _iterator13()).done;) {
      var observer = _step13.value;
      (0, _CallbackHelper.raiseCallback)(observer, observer.onTrackingError, trackingError, session);
    }
  };
  _proto.removeAnalyticObserver = function removeAnalyticObserver(listener) {
    this.observers.splice(this.observers.indexOf(listener));
  };
  _proto.reportsSuppressed = function reportsSuppressed() {
    return this.suppress;
  };
  _proto.shouldSuppress = function shouldSuppress(event) {
    var category = _TrackingReport.TrackingReport.categoryForEvent(event);
    return (this.properties.getExcludedCategories() & category) === 0 && this.suppress;
  };
  _proto.suppressReports = function suppressReports(suppress) {
    if (this.suppress !== suppress) {
      this.suppress = suppress;
      _YoLog.YoLog.d(_YoLog.DebugFlags.DEBUG_REPORTS, suppress ? "Suppress reports" : "Unsuppress reports");
    }
  };
  return ReportsManager;
}();
var ReportingParams = exports.ReportingParams = /*#__PURE__*/function () {
  function ReportingParams(playhead, advertStart, assetUri, macroSubstitutions) {
    /** @private */
    this.playhead = playhead;
    /** @private */
    this.advertStart = advertStart && advertStart >= 0 ? playhead - advertStart : -1;
    /** @private */
    this.assetUri = assetUri ? assetUri : "";
    /** @private */
    this.macroSubstitutions = macroSubstitutions ? macroSubstitutions : new Map();
  }
  var _proto2 = ReportingParams.prototype;
  _proto2.getAdvertStart = function getAdvertStart() {
    return this.advertStart;
  };
  _proto2.getAssetUri = function getAssetUri() {
    return this.assetUri;
  };
  _proto2.getMacroSubstitutions = function getMacroSubstitutions() {
    return this.macroSubstitutions;
  };
  _proto2.getPlayhead = function getPlayhead() {
    return this.playhead;
  };
  return ReportingParams;
}();